<template>
	<div id="footer" class="section">

	</div>
</template>

<script>
	export default {
		name: "LandingPageFooterSection",
		data () {
			return {}
		}
	}
</script>

<style lang="scss" scoped>
	#footer {
		min-height: 50px;
	}
</style>


// WEBPACK FOOTER //
// src/components/landingPage/footerSection.vue